import { Injectable } from '@angular/core';
import { ApiService } from '../..';

@Injectable()
export class ThongKeDangNhapService {
  constructor(public api: ApiService) { }
  APIURL_Chung = "api/ExcuteOracle"
  xuatEXCEL(mataikhoan,danhmuc, tungay, denngay, donvi, filename) {
    let cols = [];
    cols = [
      { "name": "rnum", "label": "STT", "horizontalalignment": "center" },
      { "name": "tendangnhap", "label": "Tên đăng nhập", "horizontalalignment": "left" },
      { "name": "thoidiem", "label": "Đăng nhập lúc", "horizontalalignment": "center" },
      { "name": "solan", "label": "Số lần đăng nhập", "horizontalalignment": "center" },
      { "name": "donvi", "label": "Đơn vị", "horizontalalignment": "left" },
    ]
    let currentUser = JSON.parse(localStorage.getItem("UserInfo"));
    var param = {
      config: JSON.stringify({ namesql: "PKG_TAIKHOAN.P_THONGKEDANGNHAP" }),
      para: JSON.stringify({
        v_mataikhoan_thuchien: currentUser.mataikhoan,
        v_mataikhoan: mataikhoan,
        v_danhmuc: danhmuc,
        v_tungay: tungay,
        v_denngay: denngay,
        v_pagenum: 0,
        v_numrecs: 10000000
      }),
      title: "THỐNG KÊ ĐĂNG NHẬP",
      header: "Đơn vị: " + donvi + " - Ngày: " + denngay,
      filename: filename,
      sheets: 'Thống kê đăng nhập',
      columns: cols,
      data: ""
    };

    return this.api.downloadFile("api/ExportExcel", param, filename);
  }
}


// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/quan-ly/thong-ke-dang-nhap/thongkedangnhap.service.ts